import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import { Box, Button } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { FC } from 'react';

interface DotStepperProps {
  steps: number;
  activeStep: number;
  onCompleted?: () => void;
  onBack?: () => void;
  onNext?: () => void;
}

export const DotStepper: FC<DotStepperProps> = ({ activeStep, steps, onBack, onNext, onCompleted }) => {
  const theme = useTheme();

  const handleNext = () => {
    if (activeStep == steps - 1) {
      onCompleted && onCompleted();
    } else {
      onNext && onNext();
    }
  };

  const handleBack = () => {
    if (activeStep !== 0) {
      onBack && onBack();
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <MobileStepper
        variant="dots"
        steps={steps}
        position="static"
        activeStep={activeStep}
        sx={{ maxWidth: 400, flexGrow: 1 }}
        nextButton={
          <Button size="small" onClick={handleNext}>
            Next
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={onBack ? activeStep === 0 : false}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button>
        }
      />
    </Box>
  );
};
